<template>
  <base-dialog @cancel="cancelDialog" :width="900">
    <div slot="header">{{$t('scope.text_782')}}</div>
    <div slot="body">
      <a-steps :current="current">
        <a-step key="step1" title="选择授权类型" />
        <a-step key="step2" title="选择功能场景" />
      </a-steps>
      <a-form-item v-show="current === 0" label="授权类型" class="mt-2" v-bind="formItemLayout">
        <a-radio-group v-model="type">
          <a-radio value="auth">{{$t('scope.auth')}}</a-radio>
          <a-radio value="maintenance">{{$t('scope.technical_support')}}</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-show="current === 1 && isAuth" label="功能场景" class="mt-2 mb-2" v-bind="formItemLayout">
        <a-radio-group v-model="featureType">
          <a-radio value="basic_ee">基础企业版</a-radio>
          <a-radio value="finops">FinOps</a-radio>
          <a-radio value="advance_ee">高级企业版</a-radio>
        </a-radio-group>
      </a-form-item>
      <feature-selector ref="featureSelector" v-if="isAuth && current === 1" :defaultItems="features" @change="handleFeaturesChange" />
      <a-form v-show="current === 0" :form="form.fc">
        <a-form-item v-show="isAuth" :label="$t('scope.text_779')" v-bind="formItemLayout">
          <a-radio-group v-decorator="decorators.used_for" @change="handleTypeDescRadioChange">
            <a-radio-button value="internal">{{$t('scope.internal_test')}}</a-radio-button>
            <a-radio-button value="test">{{$t('scope.commercial_evaluation')}}</a-radio-button>
            <a-radio-button value="community" :disabled="true">{{$t('scope.community')}}</a-radio-button>
            <a-radio-button value="commercial">{{$t('scope.commercial_license')}}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item>
          <a-alert :message="alertMessage" type="warning" show-icon v-show="isAuth" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_787')" v-bind="formItemLayout">
          <base-select
            v-decorator="decorators.licensee_id"
            remote
            class="w-100"
            resource="customers"
            :params="customerParams"
            :disabled="Boolean(params.customer_id)"
            :select-props="{ placeholder: $t('scope.text_788') }" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_318')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.licensee" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_778')" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.service_num" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
        <a-form-item :label="$t('scope.licenses.virthost_arm.title')" v-bind="formItemLayout" v-if="isAuth && (usedFor === 'internal' || usedFor === 'commercial')">
          <a-input-number v-decorator="decorators.virt_arm_limit" :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.licenses.virthost.title')" v-bind="formItemLayout" v-if="isAuth && (usedFor === 'internal' || usedFor === 'commercial')">
          <a-input-number v-decorator="decorators.limit" :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.licenses.cmp_server.title')" v-bind="formItemLayout" v-if="isAuth && (usedFor === 'internal' || usedFor === 'commercial')">
          <a-input-number v-decorator="decorators.server_limit" :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.licenses.cmp_host.title')" v-bind="formItemLayout" v-if="isAuth && (usedFor === 'internal' || usedFor === 'commercial')">
          <a-input-number v-decorator="decorators.cmp_host_limit" :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.licenses.baremetal_arm.title')" v-bind="formItemLayout" v-if="isAuth && (usedFor === 'internal' || usedFor === 'commercial')">
          <a-input-number v-decorator="decorators.baremetal_arm_limit" :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.licenses.baremetal.title')" v-bind="formItemLayout" v-if="isAuth && (usedFor === 'internal' || usedFor === 'commercial')">
          <a-input-number v-decorator="decorators.baremetal_limit" :min="0" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_854')" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.description" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
        <a-form-item v-if="isAuth" :label="$t('scope.text_791')" v-bind="formItemLayout">
          <a-date-picker
            v-decorator="decorators.expire"
            :disabled="usedFor === 'test' || usedFor === 'community'"
            format="YYYY-MM-DD"
            :disabled-date="disabledDate" />
        </a-form-item>
        <a-form-item v-else label="技术支持到期时间" v-bind="formItemLayout">
          <a-date-picker
            v-decorator="decorators.expire"
            format="YYYY-MM-DD" />
        </a-form-item>
      </a-form>
      <a-alert class="mt-4" type="info" v-if="current === 1 && !isAuth" message="技术支持无需选择功能" />
      <a-alert type="error" v-if="showAlert" message="请至少选择一项功能" banner />
    </div>
    <div slot="footer">
      <span class="mr-4" v-if="days">
        <span class="text-truncate">{{$t('scope.text_288')}}</span>
        <span class="ml-2">
          <span class="price">
            <template>
              <m-animated-number :value="days" :formatValue="formatToDay" :easing="'steps(1)'" />
            </template>
          </span>
        </span>
      </span>
      <span class="mr-4" v-if="price">
        <span class="text-truncate">{{$t('common_419')}}</span>
        <span class="ml-2">
          <span class="price">
            <template>
              <m-animated-number :value="price" :formatValue="formatToPrice" />
            </template>
          </span>
        </span>
      </span>
      <a-button :loading="loading" :type="isSetpOne ? 'primary': ''" @click="handleStepClick" :disabled="showAlert">{{ isSetpOne ? $t('scope.text_108') : $t('scope.text_107') }}</a-button>
      <a-button class="ml-2" type="primary" :loading="loading" v-show="!isSetpOne" @click="handleConfirm">{{ $t('dialog.ok') }}</a-button>
      <a-button class="ml-2" @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import numerify from '../constants/formatters'
import c from '@/constants/feature'
import FeatureSelector from '@/components/FeatureSelector'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { billItems } from '@/utils/auth'

export default {
  name: 'ApplyLicenseDialog',
  components: { FeatureSelector },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { isClone = false, data = {} } = this.params
    const {
      features = '',
      used_for: initUsedFor = 'test',
      licensee_id: initLicenseeId = '',
      licensee: initLicensee = '',
      service_num: initServiceNum = '',
      virt_arm_limit: initVirtArmLimit = 0,
      limit: initLimit = 0,
      server_limit: initServerLimit = 0,
      cmp_host_limit: initCmpHostLimit = 0,
      baremetal_arm_limit: initBaremetalArmLimit = 0,
      baremetal_limit: initBaremetalLimit = 0,
      description = '',
    } = data
    const initFeatures = features ? features.split(',') : []
    const billTargetItems = initFeatures.filter(key => billItems.includes(key))
    if (initFeatures.includes('bill')) {
      // 兼容旧版本license只签发bill情况
      if (!billTargetItems.length) {
        initFeatures.push(...billItems)
      }
    }
    if (initFeatures.includes('monitor') && !initFeatures.includes('monitor_operation')) {
      initFeatures.push('monitor_operation')
    }
    if (initFeatures.includes('monitor_operation') && !initFeatures.includes('monitor')) {
      initFeatures.push('monitor')
    }
    let initExpire = ''
    if (initUsedFor === 'test') {
      initExpire = this.$moment().add(1, 'months')
    } else if (initUsedFor === 'community') {
      initExpire = this.$moment('2099-12-30')
    }
    return {
      current: 0,
      showAlert: false,
      isClone,
      features: initFeatures.length ? initFeatures : c.items.map((item) => { return item.key }),
      loading: false,
      form: {
        fc: this.$form.createForm(this, { onValuesChange: this.handleValuesChange }),
        fd: {},
      },
      decorators: {
        used_for: [
          'used_for',
          {
            initialValue: initUsedFor,
          },
        ],
        licensee_id: [
          'licensee_id',
          {
            initialValue: initLicenseeId,
            rules: [
              { required: true, message: this.$t('scope.text_788') },
            ],
          },
        ],
        licensee: [
          'licensee',
          {
            initialValue: initLicensee,
            rules: [
              { required: true, message: this.$t('scope.text_332') },
            ],
          },
        ],
        service_num: [
          'service_num',
          {
            initialValue: initServiceNum,
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_792') },
              { validator: this.checkServiceNum },
            ],
          },
        ],
        virt_arm_limit: [
          'virt_arm_limit',
          {
            initialValue: initVirtArmLimit,
          },
        ],
        limit: [
          'limit',
          {
            initialValue: initLimit,
          },
        ],
        server_limit: [
          'server_limit',
          {
            initialValue: initServerLimit,
          },
        ],
        cmp_host_limit: [
          'cmp_host_limit',
          {
            initialValue: initCmpHostLimit,
          },
        ],
        baremetal_arm_limit: [
          'baremetal_arm_limit',
          {
            initialValue: initBaremetalArmLimit,
          },
        ],
        baremetal_limit: [
          'baremetal_limit',
          {
            initialValue: initBaremetalLimit,
          },
        ],
        description: [
          'description',
          {
            initialValue: description,
          },
        ],
        expire: [
          'expire',
          {
            initialValue: initExpire,
            rules: [
              { required: true, message: this.$t('scope.text_795') },
            ],
          },
        ],

      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      customerParams: {
        limit: 20,
        details: true,
        is_agent: false,
      },
      usedFor: initUsedFor,
      type: 'auth', // auth - 授权 / maintenance - 技术支持
      featureType: 'advance_ee',
    }
  },
  computed: {
    isSetpOne () {
      return this.current === 0
    },
    days () {
      let ret
      try {
        const fd = this.form.fd
        if (fd.used_for && fd.expire) {
          ret = this.$moment(fd.expire).diff(this.$moment(), 'days') + 1
        }
        return ret
      } catch (e) {
        return ret
      }
    },
    price () {
      let ret
      try {
        const fd = this.form.fd
        if (fd.used_for === 'commercial' && fd.server_limit && fd.limit && this.days) {
          return (fd.server_limit * 100 + fd.limit * 1000) * this.days / 365
        }
        return ret
      } catch (e) {
        return ret
      }
    },
    alertMessage () {
      if (this.usedFor === 'internal') {
        return this.$t('scope.internal_test.alert')
      } else if (this.usedFor === 'test') {
        return this.$t('scope.commercial_evaluation.alert')
      } else if (this.usedFor === 'community') {
        return this.$t('scope.community.alert')
      } else if (this.usedFor === 'commercial') {
        return this.$t('scope.commercial_license.alert')
      } else {
        return ''
      }
    },
    isAuth () {
      return this.type === 'auth'
    },
  },
  watch: {
    featureType () {
      this.changeFeatures()
    },
  },
  methods: {
    changeFeatures () {
      let features = [...this.features]
      if (this.featureType === 'advance_ee') {
        features = c.items.map((item) => { return item.key })
      } else if (this.featureType === 'finops') {
        features = [...billItems, 'auth', 'business_feature', 'suggestion', 'en', 'zh-CN', 'ja-JP']
      } else if (this.featureType === 'basic_ee') {
        features = c.items.map((item) => { return item.key }).filter(key => {
          return !['bastionhost', 'extdb', ...billItems, 'bill_private', 'bill_extdb', 'bill_kubernetes', 'suggestion', 'bill', 'report', 'dstack', 'zettakit', 'uis', 'sangfor', 'bingo_cloud', 'hcso', 'hcs', 'h3c', 'bingocloud', 'incloudsphere'].includes(key)
        })
      }
      this.$refs.featureSelector.changeItems(features)
    },
    handleFeaturesChange (items) {
      this.features = items
      this.showAlert = items.length === 0
    },
    formatToDay (val) {
      return `${val} 天`
    },
    formatToPrice (val) {
      return numerify(val, '0.00 RMB')
    },
    handleValuesChange (props, values) {
      this.form.fd = {
        ...this.form.fd,
        ...values,
      }
    },
    disabledDate (current) {
      if (this.usedFor === 'internal') {
        return current && (current < this.$moment().endOf('day') || current > this.$moment().add(6, 'month'))
      }
      return current && (current < this.$moment().endOf('day') || current > this.$moment().add(100, 'y'))
    },
    handleTypeDescRadioChange (e) {
      this.usedFor = e.target.value
      if (this.usedFor === 'test') {
        this.form.fc.setFieldsValue({ expire: this.$moment().add(1, 'months') })
      } else if (this.usedFor === 'community') {
        this.form.fc.setFieldsValue({ expire: this.$moment('2099-12-30') })
      } else {
        this.form.fc.setFieldsValue({ expire: '' })
      }
    },
    checkServiceNum (rule, value, callback) {
      if (value.length < 32) {
        const error = this.$t('scope.text_796')
        return callback(error)
      }
      return callback()
    },
    doApply (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    async handleStepClick () {
      if (this.isSetpOne) {
        try {
          await this.form.fc.validateFields()
          this.current = this.current + 1
        } catch (err) {}
      } else {
        this.current = this.current - 1
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        values.service_num = values.service_num.replace(/\n/g, ',')
        values.expire = this.$moment(values.expire).format('YYYY-MM-DD')
        values.features = this.features
        const billTargetItems = this.features.filter(key => billItems.includes(key))
        if (billTargetItems.length) {
          if (!this.features.includes('bill')) {
            values.features.push('bill')
          }
        } else {
          values.features = values.features.filter(key => key !== 'bill')
        }
        if (!this.isAuth) {
          values.used_for = 'commercial'
          values.features = ['maintenance']
        }
        if (values.features.includes('monitor_operation') && !values.features.includes('monitor')) {
          values.features.push('monitor')
        }
        if (values.features.includes('monitor') && !values.features.includes('monitor_operation')) {
          values.features.push('monitor_operation')
        }
        await this.doApply({ ...values, service_type: 'compute' })
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('scope.text_521'))
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style scoped>
.price {
  font-size: 30px;
  color: red;
}
</style>
